import Tooltip from '@material-ui/core/Tooltip';
import { ReactElement } from 'react';

interface DisabledFilterTooltipProps {
  enabled?: boolean;
  children: ReactElement;
}

export function DisabledFilterTooltip({
  children,
  enabled
}: DisabledFilterTooltipProps) {
  if (!enabled) {
    return children;
  }

  return (
    <Tooltip title='Filtering options are not available for this view'>
      <div>{children}</div>
    </Tooltip>
  );
}
